// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/TeamForm/TeamForm.css */

.team-form-container {
    margin: auto;
    font-family: 'Arial', sans-serif;
    width: 98.5%;
}

.team-titlee {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0.5rem 0;
    margin: 0;
}

.team-name {
    /* position: absolute; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    margin: auto;
    color: #364C63;
    font-size: 1.5rem;
    z-index: 0;
}

.team-prompt {
    color: white;
    margin: 0;
    font-size: 1.5rem;
    line-height: 1.75rem;
    background: linear-gradient(135deg, #EF6F53 0%, #e85a3c 100%);
    border-radius: 8px;
    padding: 0.5rem;
    box-shadow: 0 2px 4px rgba(239, 111, 83, 0.2);
    transition: all 0.3s ease;
    border: none;
    position: relative;
    overflow: hidden;
}

.team-prompt::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: rgba(255, 255, 255, 0.3);
}

.team-prompt:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(239, 111, 83, 0.3);
    background: linear-gradient(135deg, #e85a3c 0%, #EF6F53 100%);
}

.view-records-btn {
    padding: 0.2rem 0.8rem;
    font-size: 0.8rem;
    background-color: #364C63;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 1;
}

.view-records-btn:hover {
    background-color: #1e2a38;
    color: #ffffff;
}

.team-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 1rem;
    margin: 0;
}

.info-section {
    background: #f3f3f3;
    padding: 0.1rem;
    border-radius: 8px;
    margin-top: 0.75rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.info-section h2 {
    color: #0056b3;
    margin: 0 0 0.5rem 0;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    padding-bottom: 0.1rem;
    border-bottom: solid 2px #EF6F53;
}

.detail-item {
    display: flex;
    margin-bottom: 0.5rem;
    align-items: center;
}

.info_pair {
    display: flex;
    align-items: center;
    flex: 1 1;
}

.info_pair label {
    color: #364C63;
    font-weight: 800;
    text-align: left;
    font-size: 0.8rem;
}

.info_pair span {
    color: #7c8084;
    text-align: left;
    font-size: 0.8rem;
    flex: 1 1;
    margin-left: 0.5rem;
}

.team-detail {
    color: #364C63;
    text-align: justify;
    font-size: 0.8rem;
}

.team-memberss {
    margin-top: 1rem;
    background-color: #f3f3f3;
    padding: 0.5rem;
    border-radius: 8px;
}

.team-memberss h2 {
    font-size: 1.25rem;
    color: #0056b3;
    margin-bottom: 0.5rem;
    font-weight: bold;
    text-align: left;
}

.members-grid {
    display: flex;
    overflow-x: auto;
    gap: 1rem;
    padding: 0.5rem;
    scrollbar-width: thin;
    scrollbar-color: #EF6F53 #CFD8DC;
    -webkit-overflow-scrolling: touch;
}

.members-grid::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.members-grid::-webkit-scrollbar-track {
    background: #CFD8DC;
    border-radius: 4px;
}

.members-grid::-webkit-scrollbar-thumb {
    background-color: #EF6F53;
    border-radius: 4px;
}

.members-grid::-webkit-scrollbar-thumb:hover {
    background-color: #EF6F53;
}


.member-card {
    flex: 0 0 290px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    padding: 0.85rem;
    margin-left: 0;
    border-radius: 8px;
    box-shadow: 0 12px 26px rgba(36, 52, 71, 0.12);
    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
    border: 1px solid rgba(25, 118, 210, 0.12);
    border-bottom: 3px solid #EF6F53;
}

.member-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 34px rgba(36, 52, 71, 0.16);
    border-color: rgba(239, 111, 83, 0.28);
}

.member-card h3 {
    font-size: 1.08rem;
    color: #243447;
    margin: 0;
    border-bottom: 0;
    font-weight: 900;
    overflow-wrap: anywhere;
}

.member-details {
    font-size: 0.8rem;
    text-align: left;
}

.member-details p {
    margin: 0.32rem 0;
    color: #4a5568;
    overflow-wrap: anywhere;
}

.member-details strong {
    color: #24516f;
}

.loading {
    font-size: 2rem;
    color: #364C63;
    text-align: center;
    padding: 1rem;
}

.error {
    font-size: 1.2rem;
    color: #e53e3e;
    text-align: center;
    padding: 1rem;
    background: #fff5f5;
    border-radius: 8px;
    margin: auto;
    max-width: 600px;
}

.bottom-actions {
    display: flex;
    justify-content: center;
}

.add-record-btn{
    display: flex;
    width: 20%;
    background: linear-gradient(135deg, #EF6F53, #d85a41);
    color: white;
    border: none;
    padding: 0.45rem 0.75rem;
    font-size: 0.95rem;
    font-weight: 800;
    border-radius: 7px;
    cursor: pointer;
    margin: auto;
    align-items:center ;
    justify-content: center;
    margin-bottom: 0.5rem;
    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.24);
    transition: transform 160ms ease, filter 160ms ease, box-shadow 160ms ease;
}

.add-record-btn:hover{
    filter: brightness(1.03);
    transform: translateY(-2px); 
    box-shadow: 0 14px 28px rgba(239, 111, 83, 0.3);
}

/* Edit Member Form */
.edit-member-form {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

.edit-member-form h3 {
    margin-bottom: 15px;
    color: #333;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    color: #555;
}

.form-group input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

.form-actions button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.form-actions button[type="submit"] {
    background-color: #1976d2;
    color: white;
}

.form-actions button[type="button"] {
    background-color: #f5f5f5;
    color: #333;
}

.button-containerrrr{
    display: flex;
    justify-content: center;
    gap: 0.25rem;
}
.create-buttonn {
    background-color: #24516f;
    color: white;
    border: none;
    padding: 7px 12px;
    border-radius: 7px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 800;
    transition: transform 160ms ease, filter 160ms ease;
}

.create-buttonn:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
}

.cancel-buttonn {
    background-color: #eef2f6;
    color: #364C63;
    border: 1px solid rgba(54, 76, 99, 0.16);
    padding: 7px 12px;
    border-radius: 7px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 800;
    transition: transform 160ms ease, filter 160ms ease;
}

.cancel-buttonn:hover {
    filter: brightness(0.98);
    transform: translateY(-1px);
}

.create-buttonn:disabled,
.cancel-buttonn:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}
/* Member Actions */
.member-actions {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}

.member-actions button {
    padding: 7px 12px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 800;
    transition: transform 160ms ease, filter 160ms ease;
}

.member-actions button:first-child {
    background-color: #24516f;
    color: white;
}

.member-actions button:last-child {
    background-color: #dc3545;
    color: white;
}

.member-actions button:hover {
    transform: translateY(-1px);
    filter: brightness(1.05);
}

.member-actions button:last-child:hover {
    transform: translateY(-1px);
    filter: brightness(1.04);
}

/* Success and Error Messages */
.success-message,
.error-message {
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 15px;
}

.success-message {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.error-message {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

@media (max-width: 768px) {
    .team-form-container {
        padding: 1rem;
    }

    .team-header {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }

    .team-header h1 {
        font-size: 1.5rem;
    }

    .team-info {
        grid-template-columns: 1fr;
    }

    .info-section h2 {
        font-size: 1rem;
    }

    .detail-item span {
        font-size: 0.9rem;
    }

    .team-detail {
        font-size: 0.9rem;
    }
    .add-record-btn{
        width: 30%;
        font-size: 0.8rem;
    }
}

/* Professional team detail layout */
.team-form-container {
    width: 100%;
    margin: 0 auto;
    padding: 4px;
    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    color: #25364a;
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: hidden;
}

.team-form-container *,
.team-form-container *::before,
.team-form-container *::after {
    box-sizing: border-box;
}

.team-hero {
    display: block;
    min-height: auto;
    padding: 8px;
    border-radius: 8px;
    background:
        linear-gradient(135deg, rgba(36, 81, 111, 0.96), rgba(25, 118, 210, 0.9)),
        radial-gradient(circle at 15% 25%, rgba(239, 111, 83, 0.32), transparent 32%);
    color: #ffffff;
    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.18);
    overflow: hidden;
    max-width: 100%;
}

.team-hero-top,
.team-hero-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    margin-bottom: 0;
    min-width: 0;
}

.team-hero-row {
    width: 100%;
    justify-content: space-between;
}

.team-title-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 0;
    flex: 1 1 auto;
}

.team-hero-main {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.team-avatar,
.member-avatar {
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    color: #ffffff;
    font-weight: 800;
    letter-spacing: 0;
}

.team-avatar {
    width: 76px;
    height: 76px;
    border-radius: 8px;
    background: linear-gradient(135deg, #ef6f53, #f49b3f);
    border: 1px solid rgba(255, 255, 255, 0.38);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.18);
    font-size: 1.5rem;
}

.team-heading-block {
    min-width: 0;
    width: 100%;
    text-align: left;
}

.team-eyebrow {
    display: inline-flex;
    align-items: center;
    margin-bottom: 0;
    color: #ffffff;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
    padding: 4px 9px;
    border-radius: 999px;
    background: rgba(239, 111, 83, 0.94);
    border: 1px solid rgba(255, 255, 255, 0.24);
    white-space: nowrap;
}

.team-members-header .team-eyebrow {
    color: #ef6f53;
    padding: 0;
    background: transparent;
    border: 0;
}

.team-name {
    margin: 0;
    color: #ffffff;
    font-size: 2rem;
    line-height: 1.1;
    font-weight: 900;
    text-align: left;
    overflow-wrap: anywhere;
    word-break: normal;
    flex: 1 1 auto;
    min-width: 0;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.22);
}

.team-extension-label {
    display: block;
    color: #ffffff;
    font-size: 0.88rem;
    font-weight: 850;
    line-height: 1.2;
    white-space: nowrap;
}

.team-extension-call-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    margin-left: auto;
    width: 34px;
    height: 34px;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 999px;
    background: linear-gradient(135deg, #00f5d4, #00bbf9 48%, #fee440);
    color: #102030;
    cursor: pointer;
    box-shadow: 0 10px 22px rgba(0, 187, 249, 0.28);
    transition: background 160ms ease, color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.team-extension-call-button:hover:not(:disabled) {
    background: linear-gradient(135deg, #ff006e, #fb5607);
    border-color: rgba(255, 255, 255, 0.78);
    color: #ffffff;
    box-shadow: 0 10px 24px rgba(255, 0, 110, 0.34);
}

.team-extension-call-button:disabled {
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.24);
    color: rgba(255, 255, 255, 0.68);
    box-shadow: none;
}

.team-company-search {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    margin-left: auto;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.32);
    border-radius: 999px;
    padding: 4px 4px 4px 14px;
    gap: 6px;
    backdrop-filter: blur(4px);
    transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.team-company-search:focus-within {
    background: rgba(255, 255, 255, 0.22);
    border-color: rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 0 3px rgba(239, 111, 83, 0.28);
}

.team-company-search-input {
    border: none;
    outline: none;
    background: transparent;
    color: #ffffff;
    font-size: 0.85rem;
    font-weight: 600;
    width: 180px;
    min-width: 0;
}

.team-company-search-input::placeholder {
    color: rgba(255, 255, 255, 0.78);
    font-weight: 500;
}

.team-company-search-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff8a65 0%, #ef6f53 45%, #e73710 100%);
    color: #ffffff;
    cursor: pointer;
    box-shadow: 0 6px 14px rgba(231, 55, 16, 0.4);
    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
}

.team-company-search-button:hover {
    transform: scale(1.08);
    box-shadow: 0 8px 18px rgba(231, 55, 16, 0.5);
    filter: brightness(1.05);
}

.team-company-search-button:active {
    transform: scale(0.96);
}

@media (max-width: 720px) {
    .team-hero-row {
        flex-wrap: wrap;
    }

    .team-company-search {
        margin-left: 0;
        width: 100%;
    }

    .team-company-search-input {
        width: 100%;
    }
}

.team-record-actions {
    gap: 10px;
    margin: 12px auto 0;
    padding-top: 10px;
    border-top: 1px solid rgba(36, 52, 71, 0.12);
}

.team-record-actions .view-records-btn,
.team-record-actions .add-record-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: 132px;
    margin: 0;
    margin-bottom: 0;
}

.team-name-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    min-width: 0;
}

.team-meta-row {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 6px;
    max-width: 100%;
}

.team-meta-row span {
    padding: 3px 7px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.92);
    font-size: 0.78rem;
    font-weight: 700;
    max-width: 100%;
    overflow-wrap: anywhere;
}

.view-records-btn,
.add-record-btn {
    width: auto;
    min-width: 108px;
    padding: 6px 10px;
    border: 0;
    border-radius: 7px;
    font-size: 0.86rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
}

.view-records-btn {
    background: rgba(255, 255, 255, 0.96);
    color: #24516f;
    box-shadow: 0 9px 22px rgba(0, 0, 0, 0.16);
}

.view-records-btn:hover,
.add-record-btn:hover {
    transform: translateY(-2px);
    filter: brightness(1.03);
}

.team-prompt {
    margin: 5px 0 0;
    padding: 8px 11px;
    color: #21384f;
    background:
        linear-gradient(135deg, #fff8f1 0%, #edf6ff 58%, #ffffff 100%);
    border: 1px solid rgba(25, 118, 210, 0.18);
    border-left: 4px solid #ef6f53;
    border-radius: 8px;
    box-shadow: 0 10px 22px rgba(36, 52, 71, 0.1);
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5;
    overflow-wrap: anywhere;
}

.team-prompt:hover {
    background:
        linear-gradient(135deg, #fff2e5 0%, #e8f4ff 58%, #ffffff 100%);
    border-color: rgba(239, 111, 83, 0.28);
    box-shadow: 0 12px 26px rgba(36, 52, 71, 0.14);
}


.team-tabs {
    display: flex;
    gap: 6px;
    width: 100%;
    margin-top: 5px;
    padding: 5px;
    border: 1px solid rgba(25, 118, 210, 0.2);
    border-radius: 8px;
    background: linear-gradient(180deg, #ffffff, #f4f8fc);
    box-shadow: 0 8px 18px rgba(36, 52, 71, 0.08);
}

.team-tabs button {
    flex: 1 1;
    min-width: 0;
    padding: 8px 12px;
    border: 1px solid rgba(36, 52, 71, 0.16);
    border-radius: 6px;
    background: #ffffff;
    color: #24516f;
    cursor: pointer;
    font-size: 0.92rem;
    font-weight: 800;
    box-shadow: 0 5px 12px rgba(36, 52, 71, 0.07);
    transition:
        transform 160ms ease,
        background-color 160ms ease,
        color 160ms ease,
        border-color 160ms ease,
        box-shadow 160ms ease;
}

.team-tabs button.active {
    background: linear-gradient(135deg, #24516f, #1976d2);
    color: #ffffff;
    border-color: rgba(25, 118, 210, 0.35);
    box-shadow: 0 9px 20px rgba(25, 118, 210, 0.22);
}

.team-tabs button:hover:not(.active) {
    background: #eef6ff;
    border-color: rgba(25, 118, 210, 0.32);
    color: #1976d2;
    transform: translateY(-1px);
    box-shadow: 0 9px 20px rgba(36, 52, 71, 0.12);
}

.team-tab-panel {
    width: 100%;
    margin-top: 5px;
    min-width: 0;
}

.team-info {
    grid-template-columns: minmax(0, 1.25fr) minmax(280px, 0.75fr);
    gap: 6px;
    margin-top: 6px;
    min-width: 0;
    max-width: 100%;
}

.about-section,
.details-section {
    width: 100%;
}

.info-section,
.team-memberss {
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(25, 118, 210, 0.12);
    border-radius: 8px;
    box-shadow: 0 14px 34px rgba(36, 52, 71, 0.11);
    min-width: 0;
}

.info-section {
    padding: 8px;
    margin-top: 0;
}

.info-section h2,
.team-memberss h2 {
    color: #24516f;
    text-align: left;
    border: 0;
    padding: 0;
    margin: 0 0 6px;
    font-size: 1.02rem;
    font-weight: 800;
}

.detail-item {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 5px;
    margin-bottom: 5px;
    min-width: 0;
}

.detail-item:last-child {
    grid-template-columns: 1fr;
    margin-bottom: 0;
}

.info_pair {
    align-items: flex-start;
    gap: 3px;
    min-width: 0;
    padding: 5px 6px;
    border-radius: 7px;
    background: #f8fafc;
    border: 1px solid rgba(36, 52, 71, 0.08);
    min-width: 0;
}

.info_pair label {
    min-width: 0;
    flex: 0 0 auto;
    color: #24516f;
    font-size: 0.76rem;
    font-weight: 800;
    white-space: nowrap;
}

.info_pair span {
    color: #667085;
    font-size: 0.8rem;
    overflow-wrap: anywhere;
    min-width: 0;
}

.team-detail {
    margin: 0;
    color: #667085;
    text-align: left;
    font-size: 0.9rem;
    line-height: 1.55;
    overflow-wrap: anywhere;
}

.team-memberss {
    margin-top: 4px;
    padding: 6px;
    border: 1px solid rgba(36, 52, 71, 0.1);
    background:
        linear-gradient(180deg, #ffffff 0%, #f5f9fc 100%);
    box-shadow: 0 14px 30px rgba(36, 52, 71, 0.08);
    max-height: min(66vh, 720px);
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-gutter: stable;
}

.team-members-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-bottom: 5px;
    min-width: 0;
    text-align: center;
}

.team-members-header h2 {
    margin-bottom: 0;
    text-align: center;
}

.team-members-header .team-eyebrow {
    justify-content: center;
    width: 100%;
}

.header-add-record,
.hero-add-record {
    margin: 0;
    background: linear-gradient(135deg, #ef6f53, #f28d44);
    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.24);
}

.hero-add-record {
    flex: 0 0 auto;
    color: #ffffff;
    min-width: 124px;
    padding: 6px 10px;
}

.members-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 7px;
    align-items: stretch;
    overflow: visible;
    padding: 0;
    min-width: 0;
    max-width: 100%;
}

.member-card {
    position: relative;
    flex: unset;
    width: auto;
    min-height: 126px;
    margin: 0;
    padding: 0;
    border-radius: 8px;
    background:
        linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    border: 1px solid rgba(25, 118, 210, 0.16);
    box-shadow: 0 14px 30px rgba(36, 52, 71, 0.12);
    transition: transform 170ms ease, box-shadow 170ms ease, border-color 170ms ease, filter 170ms ease;
    min-width: 0;
    overflow: hidden;
}

.member-card::before {
    content: '';
    position: absolute;
    inset: 0 0 auto;
    height: 4px;
    background: linear-gradient(90deg, #ef6f53, #f5b041, #1976d2);
}

.member-card:hover {
    transform: translateY(-3px);
    border-color: rgba(239, 111, 83, 0.36);
    box-shadow: 0 22px 42px rgba(36, 52, 71, 0.18);
    filter: saturate(1.03);
}

.member-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 7px;
    padding: 7px 8px;
    margin-bottom: 0;
    border-bottom: 1px solid rgba(25, 118, 210, 0.12);
    background:
        linear-gradient(135deg, #243447 0%, #24516f 48%, #1976d2 100%);
    min-width: 0;
}

.member-identity {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.member-call-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
    border: 1px solid rgba(255, 255, 255, 0.42);
    border-radius: 999px;
    background:
        linear-gradient(135deg, #18c56e 0%, #12a66a 48%, #0e8f7b 100%);
    color: #ffffff;
    cursor: pointer;
    box-shadow:
        0 10px 22px rgba(18, 166, 106, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.24);
    transition: transform 160ms ease, filter 160ms ease, box-shadow 160ms ease, border-color 160ms ease;
}

.member-call-button:hover:not(:disabled) {
    filter: brightness(1.08);
    transform: translateY(-2px) scale(1.04);
    border-color: rgba(255, 255, 255, 0.68);
    box-shadow:
        0 14px 28px rgba(18, 166, 106, 0.38),
        0 0 0 4px rgba(34, 197, 94, 0.16),
        inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.member-call-button:disabled {
    cursor: not-allowed;
    background: #a6adb7;
    color: #f4f6f8;
    opacity: 1;
    box-shadow: none;
}

.member-call-button i {
    font-size: 0.9rem;
}

.member-avatar {
    display: none;
}

.member-card h3 {
    margin: 0;
    color: #ffffff;
    border: 0;
    font-size: 0.94rem;
    line-height: 1.2;
    overflow-wrap: anywhere;
    min-width: 0;
}

.member-card-header span {
    display: block;
    margin-top: 3px;
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.78rem;
    font-weight: 800;
}

.member-details {
    display: grid;
    grid-template-columns: 0.78fr 1.22fr;
    gap: 6px;
    padding: 7px;
    font-size: 0.76rem;
    background:
        linear-gradient(180deg, #ffffff, #f8fbff);
}

.member-details p {
    display: grid;
    gap: 3px;
    margin: 0;
    padding: 6px 7px;
    border: 1px solid rgba(36, 52, 71, 0.1);
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.92);
    color: #364C63;
    text-align: left;
    min-width: 0;
    overflow-wrap: anywhere;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.86);
}

.member-details strong {
    flex: 0 0 auto;
    color: #ef6f53;
    text-align: left;
    font-size: 0.64rem;
    font-weight: 900;
    text-transform: uppercase;
}

.member-detail-value {
    color: #25364a;
    font-size: 0.76rem;
    font-weight: 800;
    line-height: 1.25;
    overflow-wrap: anywhere;
}

.member-extension-value {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    max-width: 100%;
    padding: 3px 6px;
    border-radius: 999px;
    color: #ffffff;
    background: linear-gradient(135deg, #24516f, #1976d2);
    box-shadow: 0 7px 14px rgba(25, 118, 210, 0.18);
}

.member-details a {
    color: #1976d2;
    font-weight: 850;
    text-decoration: none;
}

.member-details a:hover {
    color: #ef6f53;
    text-decoration: underline;
}

.member-actions {
    justify-content: flex-end;
    gap: 5px;
    margin: 0;
    padding: 0 9px 9px;
    background: #f8fbff;
}

.member-actions button,
.create-buttonn,
.cancel-buttonn {
    padding: 5px 8px;
    border-radius: 6px;
    font-weight: 800;
    font-size: 0.78rem;
    box-shadow: 0 7px 16px rgba(36, 52, 71, 0.12);
}

.member-actions button:first-child,
.create-buttonn {
    background: #1976d2;
}

.member-actions button:last-child,
.cancel-buttonn {
    background: #d94841;
}

.member-actions button:hover,
.member-actions button:last-child:hover {
    transform: translateY(-1px);
}

.sectionnnnn {
    padding: 8px;
    border-radius: 8px;
    border: 1px solid rgba(25, 118, 210, 0.12);
    background: #ffffff;
    box-shadow: 0 12px 28px rgba(36, 52, 71, 0.1);
}

.create-team-heading {
    margin: 0 0 6px;
    color: #24516f;
}

.empty-members {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    justify-content: center;
    min-height: 92px;
    border: 1px dashed rgba(25, 118, 210, 0.26);
    border-radius: 8px;
    background: #f8fbff;
    color: #667085;
}

.empty-members strong {
    color: #24516f;
}

.loading,
.error {
    width: min(520px, calc(100% - 32px));
    margin: 12px auto;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 12px 28px rgba(36, 52, 71, 0.12);
}

@media (max-width: 1500px) {
    .members-grid {
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }
}

@media (max-width: 1260px) {
    .members-grid {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}

@media (max-width: 1040px) {
    .members-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 860px) {
    .team-info {
        grid-template-columns: 1fr;
    }

    .detail-item {
        grid-template-columns: 1fr;
    }

    .members-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 640px) {
    .team-form-container {
        width: 100%;
        padding: 4px;
    }

    .team-members-header {
        align-items: flex-start;
        flex-direction: column;
    }

    .team-hero-row {
        flex-wrap: wrap;
    }

    .team-name {
        flex-basis: calc(100% - 36px);
        font-size: 1.6rem;
    }

    .view-records-btn,
    .header-add-record,
    .hero-add-record {
        width: 100%;
    }

    .members-grid {
        grid-template-columns: 1fr;
    }

    .member-details {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/TeamForm/TeamForm.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;IACI,YAAY;IACZ,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,6DAA6D;IAC7D,kBAAkB;IAClB,eAAe;IACf,6CAA6C;IAC7C,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,6DAA6D;AACjE;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,qBAAqB;IACrB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,6DAA6D;IAC7D,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,8CAA8C;IAC9C,gFAAgF;IAChF,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,UAAU;IACV,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,gDAAgD;IAChD,0EAA0E;AAC9E;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,qBAAqB;AACrB;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,wCAAwC;IACxC,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;AACvB;AACA,mBAAmB;AACnB;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA,+BAA+B;AAC/B;;IAEI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,UAAU;QACV,iBAAiB;IACrB;AACJ;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,6EAA6E;IAC7E,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB;;qFAEiF;IACjF,cAAc;IACd,8CAA8C;IAC9C,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,2CAA2C;IAC3C,2CAA2C;IAC3C,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,oCAAoC;IACpC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,oBAAoB;IACpB,kEAAkE;IAClE,cAAc;IACd,eAAe;IACf,+CAA+C;IAC/C,mGAAmG;AACvG;;AAEA;IACI,qDAAqD;IACrD,uCAAuC;IACvC,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,qCAAqC;IACrC,2CAA2C;IAC3C,oBAAoB;IACpB,yBAAyB;IACzB,QAAQ;IACR,0BAA0B;IAC1B,iFAAiF;AACrF;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,0EAA0E;IAC1E,cAAc;IACd,eAAe;IACf,6CAA6C;IAC7C,0EAA0E;AAC9E;;AAEA;IACI,sBAAsB;IACtB,6CAA6C;IAC7C,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qCAAqC;IACrC,0CAA0C;IAC1C,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,0EAA0E;AAC9E;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;;IAEI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;sEACkE;IAClE,0CAA0C;IAC1C,8BAA8B;IAC9B,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;sEACkE;IAClE,sCAAsC;IACtC,8CAA8C;AAClD;;;AAGA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,iBAAiB;IACjB,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;IAC7C;;;;;6BAKyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,8DAA8D;IAC9D,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,8CAA8C;IAC9C,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,uCAAuC;IACvC;yDACqD;IACrD,8CAA8C;IAC9C,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;;IAEI,SAAS;IACT,qDAAqD;IACrD,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,oBAAoB;IACpB,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB;yDACqD;IACrD,0CAA0C;IAC1C,8CAA8C;IAC9C,mGAAmG;IACnG,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,6DAA6D;AACjE;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,iDAAiD;IACjD;sEACkE;IAClE,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,oBAAoB;IACpB;sEACkE;IAClE,cAAc;IACd,eAAe;IACf;;+CAE2C;IAC3C,mGAAmG;AACvG;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;IACvC,uCAAuC;IACvC;;;8CAG0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB;iDAC6C;AACjD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,qCAAqC;IACrC,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mDAAmD;AACvD;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,qDAAqD;IACrD,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;IAGI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,oCAAoC;IACpC,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;;;QAGI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* src/components/routes/Forms/TeamForm/TeamForm.css */\n\n.team-form-container {\n    margin: auto;\n    font-family: 'Arial', sans-serif;\n    width: 98.5%;\n}\n\n.team-titlee {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    padding: 0.5rem 0;\n    margin: 0;\n}\n\n.team-name {\n    /* position: absolute; */\n    /* left: 50%; */\n    /* transform: translateX(-50%); */\n    margin: auto;\n    color: #364C63;\n    font-size: 1.5rem;\n    z-index: 0;\n}\n\n.team-prompt {\n    color: white;\n    margin: 0;\n    font-size: 1.5rem;\n    line-height: 1.75rem;\n    background: linear-gradient(135deg, #EF6F53 0%, #e85a3c 100%);\n    border-radius: 8px;\n    padding: 0.5rem;\n    box-shadow: 0 2px 4px rgba(239, 111, 83, 0.2);\n    transition: all 0.3s ease;\n    border: none;\n    position: relative;\n    overflow: hidden;\n}\n\n.team-prompt::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: rgba(255, 255, 255, 0.3);\n}\n\n.team-prompt:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(239, 111, 83, 0.3);\n    background: linear-gradient(135deg, #e85a3c 0%, #EF6F53 100%);\n}\n\n.view-records-btn {\n    padding: 0.2rem 0.8rem;\n    font-size: 0.8rem;\n    background-color: #364C63;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    z-index: 1;\n}\n\n.view-records-btn:hover {\n    background-color: #1e2a38;\n    color: #ffffff;\n}\n\n.team-info {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 1rem;\n    margin: 0;\n}\n\n.info-section {\n    background: #f3f3f3;\n    padding: 0.1rem;\n    border-radius: 8px;\n    margin-top: 0.75rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.info-section h2 {\n    color: #0056b3;\n    margin: 0 0 0.5rem 0;\n    font-size: 1rem;\n    font-weight: bold;\n    text-align: center;\n    padding-bottom: 0.1rem;\n    border-bottom: solid 2px #EF6F53;\n}\n\n.detail-item {\n    display: flex;\n    margin-bottom: 0.5rem;\n    align-items: center;\n}\n\n.info_pair {\n    display: flex;\n    align-items: center;\n    flex: 1;\n}\n\n.info_pair label {\n    color: #364C63;\n    font-weight: 800;\n    text-align: left;\n    font-size: 0.8rem;\n}\n\n.info_pair span {\n    color: #7c8084;\n    text-align: left;\n    font-size: 0.8rem;\n    flex: 1;\n    margin-left: 0.5rem;\n}\n\n.team-detail {\n    color: #364C63;\n    text-align: justify;\n    font-size: 0.8rem;\n}\n\n.team-memberss {\n    margin-top: 1rem;\n    background-color: #f3f3f3;\n    padding: 0.5rem;\n    border-radius: 8px;\n}\n\n.team-memberss h2 {\n    font-size: 1.25rem;\n    color: #0056b3;\n    margin-bottom: 0.5rem;\n    font-weight: bold;\n    text-align: left;\n}\n\n.members-grid {\n    display: flex;\n    overflow-x: auto;\n    gap: 1rem;\n    padding: 0.5rem;\n    scrollbar-width: thin;\n    scrollbar-color: #EF6F53 #CFD8DC;\n    -webkit-overflow-scrolling: touch;\n}\n\n.members-grid::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.members-grid::-webkit-scrollbar-track {\n    background: #CFD8DC;\n    border-radius: 4px;\n}\n\n.members-grid::-webkit-scrollbar-thumb {\n    background-color: #EF6F53;\n    border-radius: 4px;\n}\n\n.members-grid::-webkit-scrollbar-thumb:hover {\n    background-color: #EF6F53;\n}\n\n\n.member-card {\n    flex: 0 0 290px;\n    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n    padding: 0.85rem;\n    margin-left: 0;\n    border-radius: 8px;\n    box-shadow: 0 12px 26px rgba(36, 52, 71, 0.12);\n    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;\n    border: 1px solid rgba(25, 118, 210, 0.12);\n    border-bottom: 3px solid #EF6F53;\n}\n\n.member-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 18px 34px rgba(36, 52, 71, 0.16);\n    border-color: rgba(239, 111, 83, 0.28);\n}\n\n.member-card h3 {\n    font-size: 1.08rem;\n    color: #243447;\n    margin: 0;\n    border-bottom: 0;\n    font-weight: 900;\n    overflow-wrap: anywhere;\n}\n\n.member-details {\n    font-size: 0.8rem;\n    text-align: left;\n}\n\n.member-details p {\n    margin: 0.32rem 0;\n    color: #4a5568;\n    overflow-wrap: anywhere;\n}\n\n.member-details strong {\n    color: #24516f;\n}\n\n.loading {\n    font-size: 2rem;\n    color: #364C63;\n    text-align: center;\n    padding: 1rem;\n}\n\n.error {\n    font-size: 1.2rem;\n    color: #e53e3e;\n    text-align: center;\n    padding: 1rem;\n    background: #fff5f5;\n    border-radius: 8px;\n    margin: auto;\n    max-width: 600px;\n}\n\n.bottom-actions {\n    display: flex;\n    justify-content: center;\n}\n\n.add-record-btn{\n    display: flex;\n    width: 20%;\n    background: linear-gradient(135deg, #EF6F53, #d85a41);\n    color: white;\n    border: none;\n    padding: 0.45rem 0.75rem;\n    font-size: 0.95rem;\n    font-weight: 800;\n    border-radius: 7px;\n    cursor: pointer;\n    margin: auto;\n    align-items:center ;\n    justify-content: center;\n    margin-bottom: 0.5rem;\n    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.24);\n    transition: transform 160ms ease, filter 160ms ease, box-shadow 160ms ease;\n}\n\n.add-record-btn:hover{\n    filter: brightness(1.03);\n    transform: translateY(-2px); \n    box-shadow: 0 14px 28px rgba(239, 111, 83, 0.3);\n}\n\n/* Edit Member Form */\n.edit-member-form {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 20px;\n}\n\n.edit-member-form h3 {\n    margin-bottom: 15px;\n    color: #333;\n}\n\n.form-group {\n    margin-bottom: 15px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 5px;\n    color: #555;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.form-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 20px;\n}\n\n.form-actions button {\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.form-actions button[type=\"submit\"] {\n    background-color: #1976d2;\n    color: white;\n}\n\n.form-actions button[type=\"button\"] {\n    background-color: #f5f5f5;\n    color: #333;\n}\n\n.button-containerrrr{\n    display: flex;\n    justify-content: center;\n    gap: 0.25rem;\n}\n.create-buttonn {\n    background-color: #24516f;\n    color: white;\n    border: none;\n    padding: 7px 12px;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    font-weight: 800;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.create-buttonn:hover {\n    filter: brightness(1.06);\n    transform: translateY(-1px);\n}\n\n.cancel-buttonn {\n    background-color: #eef2f6;\n    color: #364C63;\n    border: 1px solid rgba(54, 76, 99, 0.16);\n    padding: 7px 12px;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    font-weight: 800;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.cancel-buttonn:hover {\n    filter: brightness(0.98);\n    transform: translateY(-1px);\n}\n\n.create-buttonn:disabled,\n.cancel-buttonn:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n/* Member Actions */\n.member-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.member-actions button {\n    padding: 7px 12px;\n    border: none;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 800;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.member-actions button:first-child {\n    background-color: #24516f;\n    color: white;\n}\n\n.member-actions button:last-child {\n    background-color: #dc3545;\n    color: white;\n}\n\n.member-actions button:hover {\n    transform: translateY(-1px);\n    filter: brightness(1.05);\n}\n\n.member-actions button:last-child:hover {\n    transform: translateY(-1px);\n    filter: brightness(1.04);\n}\n\n/* Success and Error Messages */\n.success-message,\n.error-message {\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n}\n\n.success-message {\n    background-color: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n}\n\n.error-message {\n    background-color: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n}\n\n@media (max-width: 768px) {\n    .team-form-container {\n        padding: 1rem;\n    }\n\n    .team-header {\n        flex-direction: column;\n        gap: 1rem;\n        text-align: center;\n    }\n\n    .team-header h1 {\n        font-size: 1.5rem;\n    }\n\n    .team-info {\n        grid-template-columns: 1fr;\n    }\n\n    .info-section h2 {\n        font-size: 1rem;\n    }\n\n    .detail-item span {\n        font-size: 0.9rem;\n    }\n\n    .team-detail {\n        font-size: 0.9rem;\n    }\n    .add-record-btn{\n        width: 30%;\n        font-size: 0.8rem;\n    }\n}\n\n/* Professional team detail layout */\n.team-form-container {\n    width: 100%;\n    margin: 0 auto;\n    padding: 4px;\n    font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n    color: #25364a;\n    box-sizing: border-box;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n\n.team-form-container *,\n.team-form-container *::before,\n.team-form-container *::after {\n    box-sizing: border-box;\n}\n\n.team-hero {\n    display: block;\n    min-height: auto;\n    padding: 8px;\n    border-radius: 8px;\n    background:\n        linear-gradient(135deg, rgba(36, 81, 111, 0.96), rgba(25, 118, 210, 0.9)),\n        radial-gradient(circle at 15% 25%, rgba(239, 111, 83, 0.32), transparent 32%);\n    color: #ffffff;\n    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.18);\n    overflow: hidden;\n    max-width: 100%;\n}\n\n.team-hero-top,\n.team-hero-row {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 0;\n    min-width: 0;\n}\n\n.team-hero-row {\n    width: 100%;\n    justify-content: space-between;\n}\n\n.team-title-text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    min-width: 0;\n    flex: 1 1 auto;\n}\n\n.team-hero-main {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n}\n\n.team-avatar,\n.member-avatar {\n    display: grid;\n    place-items: center;\n    flex: 0 0 auto;\n    color: #ffffff;\n    font-weight: 800;\n    letter-spacing: 0;\n}\n\n.team-avatar {\n    width: 76px;\n    height: 76px;\n    border-radius: 8px;\n    background: linear-gradient(135deg, #ef6f53, #f49b3f);\n    border: 1px solid rgba(255, 255, 255, 0.38);\n    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.18);\n    font-size: 1.5rem;\n}\n\n.team-heading-block {\n    min-width: 0;\n    width: 100%;\n    text-align: left;\n}\n\n.team-eyebrow {\n    display: inline-flex;\n    align-items: center;\n    margin-bottom: 0;\n    color: #ffffff;\n    font-size: 0.72rem;\n    font-weight: 800;\n    letter-spacing: 0;\n    text-transform: uppercase;\n    padding: 4px 9px;\n    border-radius: 999px;\n    background: rgba(239, 111, 83, 0.94);\n    border: 1px solid rgba(255, 255, 255, 0.24);\n    white-space: nowrap;\n}\n\n.team-members-header .team-eyebrow {\n    color: #ef6f53;\n    padding: 0;\n    background: transparent;\n    border: 0;\n}\n\n.team-name {\n    margin: 0;\n    color: #ffffff;\n    font-size: 2rem;\n    line-height: 1.1;\n    font-weight: 900;\n    text-align: left;\n    overflow-wrap: anywhere;\n    word-break: normal;\n    flex: 1 1 auto;\n    min-width: 0;\n    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.22);\n}\n\n.team-extension-label {\n    display: block;\n    color: #ffffff;\n    font-size: 0.88rem;\n    font-weight: 850;\n    line-height: 1.2;\n    white-space: nowrap;\n}\n\n.team-extension-call-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    margin-left: auto;\n    width: 34px;\n    height: 34px;\n    border: 1px solid rgba(255, 255, 255, 0.55);\n    border-radius: 999px;\n    background: linear-gradient(135deg, #00f5d4, #00bbf9 48%, #fee440);\n    color: #102030;\n    cursor: pointer;\n    box-shadow: 0 10px 22px rgba(0, 187, 249, 0.28);\n    transition: background 160ms ease, color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.team-extension-call-button:hover:not(:disabled) {\n    background: linear-gradient(135deg, #ff006e, #fb5607);\n    border-color: rgba(255, 255, 255, 0.78);\n    color: #ffffff;\n    box-shadow: 0 10px 24px rgba(255, 0, 110, 0.34);\n}\n\n.team-extension-call-button:disabled {\n    cursor: not-allowed;\n    background: rgba(255, 255, 255, 0.24);\n    color: rgba(255, 255, 255, 0.68);\n    box-shadow: none;\n}\n\n.team-company-search {\n    display: flex;\n    align-items: center;\n    flex: 0 0 auto;\n    margin-left: auto;\n    background: rgba(255, 255, 255, 0.14);\n    border: 1px solid rgba(255, 255, 255, 0.32);\n    border-radius: 999px;\n    padding: 4px 4px 4px 14px;\n    gap: 6px;\n    backdrop-filter: blur(4px);\n    transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.team-company-search:focus-within {\n    background: rgba(255, 255, 255, 0.22);\n    border-color: rgba(255, 255, 255, 0.6);\n    box-shadow: 0 0 0 3px rgba(239, 111, 83, 0.28);\n}\n\n.team-company-search-input {\n    border: none;\n    outline: none;\n    background: transparent;\n    color: #ffffff;\n    font-size: 0.85rem;\n    font-weight: 600;\n    width: 180px;\n    min-width: 0;\n}\n\n.team-company-search-input::placeholder {\n    color: rgba(255, 255, 255, 0.78);\n    font-weight: 500;\n}\n\n.team-company-search-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    width: 32px;\n    height: 32px;\n    border: none;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #ff8a65 0%, #ef6f53 45%, #e73710 100%);\n    color: #ffffff;\n    cursor: pointer;\n    box-shadow: 0 6px 14px rgba(231, 55, 16, 0.4);\n    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;\n}\n\n.team-company-search-button:hover {\n    transform: scale(1.08);\n    box-shadow: 0 8px 18px rgba(231, 55, 16, 0.5);\n    filter: brightness(1.05);\n}\n\n.team-company-search-button:active {\n    transform: scale(0.96);\n}\n\n@media (max-width: 720px) {\n    .team-hero-row {\n        flex-wrap: wrap;\n    }\n\n    .team-company-search {\n        margin-left: 0;\n        width: 100%;\n    }\n\n    .team-company-search-input {\n        width: 100%;\n    }\n}\n\n.team-record-actions {\n    gap: 10px;\n    margin: 12px auto 0;\n    padding-top: 10px;\n    border-top: 1px solid rgba(36, 52, 71, 0.12);\n}\n\n.team-record-actions .view-records-btn,\n.team-record-actions .add-record-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    min-width: 132px;\n    margin: 0;\n    margin-bottom: 0;\n}\n\n.team-name-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    width: 100%;\n    min-width: 0;\n}\n\n.team-meta-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    margin-top: 6px;\n    max-width: 100%;\n}\n\n.team-meta-row span {\n    padding: 3px 7px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.14);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    color: rgba(255, 255, 255, 0.92);\n    font-size: 0.78rem;\n    font-weight: 700;\n    max-width: 100%;\n    overflow-wrap: anywhere;\n}\n\n.view-records-btn,\n.add-record-btn {\n    width: auto;\n    min-width: 108px;\n    padding: 6px 10px;\n    border: 0;\n    border-radius: 7px;\n    font-size: 0.86rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;\n}\n\n.view-records-btn {\n    background: rgba(255, 255, 255, 0.96);\n    color: #24516f;\n    box-shadow: 0 9px 22px rgba(0, 0, 0, 0.16);\n}\n\n.view-records-btn:hover,\n.add-record-btn:hover {\n    transform: translateY(-2px);\n    filter: brightness(1.03);\n}\n\n.team-prompt {\n    margin: 5px 0 0;\n    padding: 8px 11px;\n    color: #21384f;\n    background:\n        linear-gradient(135deg, #fff8f1 0%, #edf6ff 58%, #ffffff 100%);\n    border: 1px solid rgba(25, 118, 210, 0.18);\n    border-left: 4px solid #ef6f53;\n    border-radius: 8px;\n    box-shadow: 0 10px 22px rgba(36, 52, 71, 0.1);\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 1.5;\n    overflow-wrap: anywhere;\n}\n\n.team-prompt:hover {\n    background:\n        linear-gradient(135deg, #fff2e5 0%, #e8f4ff 58%, #ffffff 100%);\n    border-color: rgba(239, 111, 83, 0.28);\n    box-shadow: 0 12px 26px rgba(36, 52, 71, 0.14);\n}\n\n\n.team-tabs {\n    display: flex;\n    gap: 6px;\n    width: 100%;\n    margin-top: 5px;\n    padding: 5px;\n    border: 1px solid rgba(25, 118, 210, 0.2);\n    border-radius: 8px;\n    background: linear-gradient(180deg, #ffffff, #f4f8fc);\n    box-shadow: 0 8px 18px rgba(36, 52, 71, 0.08);\n}\n\n.team-tabs button {\n    flex: 1;\n    min-width: 0;\n    padding: 8px 12px;\n    border: 1px solid rgba(36, 52, 71, 0.16);\n    border-radius: 6px;\n    background: #ffffff;\n    color: #24516f;\n    cursor: pointer;\n    font-size: 0.92rem;\n    font-weight: 800;\n    box-shadow: 0 5px 12px rgba(36, 52, 71, 0.07);\n    transition:\n        transform 160ms ease,\n        background-color 160ms ease,\n        color 160ms ease,\n        border-color 160ms ease,\n        box-shadow 160ms ease;\n}\n\n.team-tabs button.active {\n    background: linear-gradient(135deg, #24516f, #1976d2);\n    color: #ffffff;\n    border-color: rgba(25, 118, 210, 0.35);\n    box-shadow: 0 9px 20px rgba(25, 118, 210, 0.22);\n}\n\n.team-tabs button:hover:not(.active) {\n    background: #eef6ff;\n    border-color: rgba(25, 118, 210, 0.32);\n    color: #1976d2;\n    transform: translateY(-1px);\n    box-shadow: 0 9px 20px rgba(36, 52, 71, 0.12);\n}\n\n.team-tab-panel {\n    width: 100%;\n    margin-top: 5px;\n    min-width: 0;\n}\n\n.team-info {\n    grid-template-columns: minmax(0, 1.25fr) minmax(280px, 0.75fr);\n    gap: 6px;\n    margin-top: 6px;\n    min-width: 0;\n    max-width: 100%;\n}\n\n.about-section,\n.details-section {\n    width: 100%;\n}\n\n.info-section,\n.team-memberss {\n    background: rgba(255, 255, 255, 0.98);\n    border: 1px solid rgba(25, 118, 210, 0.12);\n    border-radius: 8px;\n    box-shadow: 0 14px 34px rgba(36, 52, 71, 0.11);\n    min-width: 0;\n}\n\n.info-section {\n    padding: 8px;\n    margin-top: 0;\n}\n\n.info-section h2,\n.team-memberss h2 {\n    color: #24516f;\n    text-align: left;\n    border: 0;\n    padding: 0;\n    margin: 0 0 6px;\n    font-size: 1.02rem;\n    font-weight: 800;\n}\n\n.detail-item {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 5px;\n    margin-bottom: 5px;\n    min-width: 0;\n}\n\n.detail-item:last-child {\n    grid-template-columns: 1fr;\n    margin-bottom: 0;\n}\n\n.info_pair {\n    align-items: flex-start;\n    gap: 3px;\n    min-width: 0;\n    padding: 5px 6px;\n    border-radius: 7px;\n    background: #f8fafc;\n    border: 1px solid rgba(36, 52, 71, 0.08);\n    min-width: 0;\n}\n\n.info_pair label {\n    min-width: 0;\n    flex: 0 0 auto;\n    color: #24516f;\n    font-size: 0.76rem;\n    font-weight: 800;\n    white-space: nowrap;\n}\n\n.info_pair span {\n    color: #667085;\n    font-size: 0.8rem;\n    overflow-wrap: anywhere;\n    min-width: 0;\n}\n\n.team-detail {\n    margin: 0;\n    color: #667085;\n    text-align: left;\n    font-size: 0.9rem;\n    line-height: 1.55;\n    overflow-wrap: anywhere;\n}\n\n.team-memberss {\n    margin-top: 4px;\n    padding: 6px;\n    border: 1px solid rgba(36, 52, 71, 0.1);\n    background:\n        linear-gradient(180deg, #ffffff 0%, #f5f9fc 100%);\n    box-shadow: 0 14px 30px rgba(36, 52, 71, 0.08);\n    max-height: min(66vh, 720px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-gutter: stable;\n}\n\n.team-members-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    margin-bottom: 5px;\n    min-width: 0;\n    text-align: center;\n}\n\n.team-members-header h2 {\n    margin-bottom: 0;\n    text-align: center;\n}\n\n.team-members-header .team-eyebrow {\n    justify-content: center;\n    width: 100%;\n}\n\n.header-add-record,\n.hero-add-record {\n    margin: 0;\n    background: linear-gradient(135deg, #ef6f53, #f28d44);\n    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.24);\n}\n\n.hero-add-record {\n    flex: 0 0 auto;\n    color: #ffffff;\n    min-width: 124px;\n    padding: 6px 10px;\n}\n\n.members-grid {\n    display: grid;\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    gap: 7px;\n    align-items: stretch;\n    overflow: visible;\n    padding: 0;\n    min-width: 0;\n    max-width: 100%;\n}\n\n.member-card {\n    position: relative;\n    flex: unset;\n    width: auto;\n    min-height: 126px;\n    margin: 0;\n    padding: 0;\n    border-radius: 8px;\n    background:\n        linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n    border: 1px solid rgba(25, 118, 210, 0.16);\n    box-shadow: 0 14px 30px rgba(36, 52, 71, 0.12);\n    transition: transform 170ms ease, box-shadow 170ms ease, border-color 170ms ease, filter 170ms ease;\n    min-width: 0;\n    overflow: hidden;\n}\n\n.member-card::before {\n    content: '';\n    position: absolute;\n    inset: 0 0 auto;\n    height: 4px;\n    background: linear-gradient(90deg, #ef6f53, #f5b041, #1976d2);\n}\n\n.member-card:hover {\n    transform: translateY(-3px);\n    border-color: rgba(239, 111, 83, 0.36);\n    box-shadow: 0 22px 42px rgba(36, 52, 71, 0.18);\n    filter: saturate(1.03);\n}\n\n.member-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 7px;\n    padding: 7px 8px;\n    margin-bottom: 0;\n    border-bottom: 1px solid rgba(25, 118, 210, 0.12);\n    background:\n        linear-gradient(135deg, #243447 0%, #24516f 48%, #1976d2 100%);\n    min-width: 0;\n}\n\n.member-identity {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n}\n\n.member-call-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    width: 34px;\n    height: 34px;\n    border: 1px solid rgba(255, 255, 255, 0.42);\n    border-radius: 999px;\n    background:\n        linear-gradient(135deg, #18c56e 0%, #12a66a 48%, #0e8f7b 100%);\n    color: #ffffff;\n    cursor: pointer;\n    box-shadow:\n        0 10px 22px rgba(18, 166, 106, 0.3),\n        inset 0 1px 0 rgba(255, 255, 255, 0.24);\n    transition: transform 160ms ease, filter 160ms ease, box-shadow 160ms ease, border-color 160ms ease;\n}\n\n.member-call-button:hover:not(:disabled) {\n    filter: brightness(1.08);\n    transform: translateY(-2px) scale(1.04);\n    border-color: rgba(255, 255, 255, 0.68);\n    box-shadow:\n        0 14px 28px rgba(18, 166, 106, 0.38),\n        0 0 0 4px rgba(34, 197, 94, 0.16),\n        inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.member-call-button:disabled {\n    cursor: not-allowed;\n    background: #a6adb7;\n    color: #f4f6f8;\n    opacity: 1;\n    box-shadow: none;\n}\n\n.member-call-button i {\n    font-size: 0.9rem;\n}\n\n.member-avatar {\n    display: none;\n}\n\n.member-card h3 {\n    margin: 0;\n    color: #ffffff;\n    border: 0;\n    font-size: 0.94rem;\n    line-height: 1.2;\n    overflow-wrap: anywhere;\n    min-width: 0;\n}\n\n.member-card-header span {\n    display: block;\n    margin-top: 3px;\n    color: rgba(255, 255, 255, 0.82);\n    font-size: 0.78rem;\n    font-weight: 800;\n}\n\n.member-details {\n    display: grid;\n    grid-template-columns: 0.78fr 1.22fr;\n    gap: 6px;\n    padding: 7px;\n    font-size: 0.76rem;\n    background:\n        linear-gradient(180deg, #ffffff, #f8fbff);\n}\n\n.member-details p {\n    display: grid;\n    gap: 3px;\n    margin: 0;\n    padding: 6px 7px;\n    border: 1px solid rgba(36, 52, 71, 0.1);\n    border-radius: 7px;\n    background: rgba(255, 255, 255, 0.92);\n    color: #364C63;\n    text-align: left;\n    min-width: 0;\n    overflow-wrap: anywhere;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.86);\n}\n\n.member-details strong {\n    flex: 0 0 auto;\n    color: #ef6f53;\n    text-align: left;\n    font-size: 0.64rem;\n    font-weight: 900;\n    text-transform: uppercase;\n}\n\n.member-detail-value {\n    color: #25364a;\n    font-size: 0.76rem;\n    font-weight: 800;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n}\n\n.member-extension-value {\n    display: inline-flex;\n    align-items: center;\n    width: fit-content;\n    max-width: 100%;\n    padding: 3px 6px;\n    border-radius: 999px;\n    color: #ffffff;\n    background: linear-gradient(135deg, #24516f, #1976d2);\n    box-shadow: 0 7px 14px rgba(25, 118, 210, 0.18);\n}\n\n.member-details a {\n    color: #1976d2;\n    font-weight: 850;\n    text-decoration: none;\n}\n\n.member-details a:hover {\n    color: #ef6f53;\n    text-decoration: underline;\n}\n\n.member-actions {\n    justify-content: flex-end;\n    gap: 5px;\n    margin: 0;\n    padding: 0 9px 9px;\n    background: #f8fbff;\n}\n\n.member-actions button,\n.create-buttonn,\n.cancel-buttonn {\n    padding: 5px 8px;\n    border-radius: 6px;\n    font-weight: 800;\n    font-size: 0.78rem;\n    box-shadow: 0 7px 16px rgba(36, 52, 71, 0.12);\n}\n\n.member-actions button:first-child,\n.create-buttonn {\n    background: #1976d2;\n}\n\n.member-actions button:last-child,\n.cancel-buttonn {\n    background: #d94841;\n}\n\n.member-actions button:hover,\n.member-actions button:last-child:hover {\n    transform: translateY(-1px);\n}\n\n.sectionnnnn {\n    padding: 8px;\n    border-radius: 8px;\n    border: 1px solid rgba(25, 118, 210, 0.12);\n    background: #ffffff;\n    box-shadow: 0 12px 28px rgba(36, 52, 71, 0.1);\n}\n\n.create-team-heading {\n    margin: 0 0 6px;\n    color: #24516f;\n}\n\n.empty-members {\n    grid-column: 1 / -1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    align-items: center;\n    justify-content: center;\n    min-height: 92px;\n    border: 1px dashed rgba(25, 118, 210, 0.26);\n    border-radius: 8px;\n    background: #f8fbff;\n    color: #667085;\n}\n\n.empty-members strong {\n    color: #24516f;\n}\n\n.loading,\n.error {\n    width: min(520px, calc(100% - 32px));\n    margin: 12px auto;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0 12px 28px rgba(36, 52, 71, 0.12);\n}\n\n@media (max-width: 1500px) {\n    .members-grid {\n        grid-template-columns: repeat(5, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 1260px) {\n    .members-grid {\n        grid-template-columns: repeat(4, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 1040px) {\n    .members-grid {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 860px) {\n    .team-info {\n        grid-template-columns: 1fr;\n    }\n\n    .detail-item {\n        grid-template-columns: 1fr;\n    }\n\n    .members-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 640px) {\n    .team-form-container {\n        width: 100%;\n        padding: 4px;\n    }\n\n    .team-members-header {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .team-hero-row {\n        flex-wrap: wrap;\n    }\n\n    .team-name {\n        flex-basis: calc(100% - 36px);\n        font-size: 1.6rem;\n    }\n\n    .view-records-btn,\n    .header-add-record,\n    .hero-add-record {\n        width: 100%;\n    }\n\n    .members-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .member-details {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
